/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ruler_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`On a phone, go full screen and measure along the edge in portrait or landscape.`)
};

const es_ruler_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En un móvil, pasa a pantalla completa y mide a lo largo del borde en vertical u horizontal.`)
};

const de_ruler_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wechsle auf dem Smartphone in den Vollbildmodus und miss entlang der Kante im Hoch- oder Querformat.`)
};

const nl_ruler_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ga op je telefoon naar volledig scherm en meet langs de rand, staand of liggend.`)
};

const fr_ruler_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sur téléphone, passez en plein écran et mesurez le long du bord en portrait ou en paysage.`)
};

const it_ruler_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Su telefono, passa a schermo intero e misura lungo il bordo in verticale o orizzontale.`)
};

const pt_br2_ruler_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No celular, entre em tela cheia e meça pela borda, na vertical ou na horizontal.`)
};

const pt_ruler_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Num telemóvel, passe a ecrã inteiro e meça ao longo da extremidade em retrato ou paisagem.`)
};

const ja_ruler_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`スマートフォンでは全画面表示にして、縦向き・横向きで端に沿って測定できます。`)
};

const zh_ruler_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在手机上，进入全屏并沿竖屏或横屏边缘测量。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ruler_ex3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ruler_ex3(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ruler_ex3", locale)
	if (locale === "en") return en_ruler_ex3(inputs)
	if (locale === "es") return es_ruler_ex3(inputs)
	if (locale === "de") return de_ruler_ex3(inputs)
	if (locale === "nl") return nl_ruler_ex3(inputs)
	if (locale === "fr") return fr_ruler_ex3(inputs)
	if (locale === "it") return it_ruler_ex3(inputs)
	if (locale === "pt-BR") return pt_br2_ruler_ex3(inputs)
	if (locale === "pt") return pt_ruler_ex3(inputs)
	if (locale === "ja") return ja_ruler_ex3(inputs)
	return zh_ruler_ex3(inputs)
};